var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navigation__quick-menu",
      class: { "navigation__quick-menu--admin": _vm.state.isAdminUser },
    },
    [
      _vm.state.hasUser
        ? [
            _c("div", { staticClass: "navigation__quick-menu__item" }, [
              _c(
                "button",
                { staticClass: "cursor-pointer", on: { click: _vm.logout } },
                [_c("i", { staticClass: "icon fas fa-sign-out-alt" })]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "label capitalize" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.i18n.t("general:non_special_text.logout")) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "navigation__quick-menu__item" }, [
              _c("div", { staticClass: "navigation__quick-menu__avatar" }, [
                _c(
                  "a",
                  { attrs: { href: "/" + _vm.state.region + "/profile" } },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.state.avatarUrl,
                        alt: "Profile " + _vm.state.id,
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "label" }, [
                _vm._v("\n        ID: " + _vm._s(_vm.state.id) + "\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "navigation__quick-menu__item" }, [
              _c(
                "a",
                {
                  attrs: { href: "/" + _vm.state.region + "/profile/payments" },
                },
                [_c("i", { staticClass: "icon far fa-credit-card" })]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "label" }, [
                _vm._v("\n        " + _vm._s(_vm.state.balance) + "\n      "),
              ]),
            ]),
          ]
        : _c(
            "div",
            {
              staticClass:
                "navigation__quick-menu__item navigation__quick-menu__item--left",
            },
            [
              _c("a", { attrs: { href: _vm.state.loginUrl } }, [
                _c("i", { staticClass: "icon far fa-user" }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "label capitalize" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.i18n.t("general:non_special_text.login")) +
                    "\n    "
                ),
              ]),
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "navigation__quick-menu__item",
          class: { "navigation__quick-menu__item--left": !_vm.state.hasUser },
        },
        [
          _c(
            "button",
            {
              staticClass: "cursor-pointer",
              on: {
                click: function ($event) {
                  return _vm.emit("openSearch")
                },
              },
            },
            [_c("i", { staticClass: "icon fas fa-search" })]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.i18n.t("general:non_special_text.search")) +
                "\n    "
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }